import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableNewContract = Loadable({
  loader: function loader() {
    return import('../NewContract.jsx');
  },
  loading: ComponentLoading
});
export default LoadableNewContract;